/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSupportIndexRouteImport } from './routes/_authenticated/support/index'
import { Route as AuthenticatedPlatformConfigIndexRouteImport } from './routes/_authenticated/platform-config/index'
import { Route as AuthenticatedModerationIndexRouteImport } from './routes/_authenticated/moderation/index'
import { Route as AuthenticatedControlsIndexRouteImport } from './routes/_authenticated/controls/index'
import { Route as AuthenticatedAuditIndexRouteImport } from './routes/_authenticated/audit/index'
import { Route as AuthenticatedAccessIndexRouteImport } from './routes/_authenticated/access/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedSupportIdRouteImport } from './routes/_authenticated/support/$id'
import { Route as AuthenticatedPlatformConfigNamespaceRouteImport } from './routes/_authenticated/platform-config/$namespace'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSupportIndexRoute =
  AuthenticatedSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPlatformConfigIndexRoute =
  AuthenticatedPlatformConfigIndexRouteImport.update({
    id: '/platform-config/',
    path: '/platform-config/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedModerationIndexRoute =
  AuthenticatedModerationIndexRouteImport.update({
    id: '/moderation/',
    path: '/moderation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedControlsIndexRoute =
  AuthenticatedControlsIndexRouteImport.update({
    id: '/controls/',
    path: '/controls/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAuditIndexRoute = AuthenticatedAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAccessIndexRoute =
  AuthenticatedAccessIndexRouteImport.update({
    id: '/access/',
    path: '/access/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSupportIdRoute = AuthenticatedSupportIdRouteImport.update({
  id: '/support/$id',
  path: '/support/$id',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPlatformConfigNamespaceRoute =
  AuthenticatedPlatformConfigNamespaceRouteImport.update({
    id: '/platform-config/$namespace',
    path: '/platform-config/$namespace',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/platform-config/$namespace': typeof AuthenticatedPlatformConfigNamespaceRoute
  '/support/$id': typeof AuthenticatedSupportIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/access': typeof AuthenticatedAccessIndexRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/controls': typeof AuthenticatedControlsIndexRoute
  '/moderation': typeof AuthenticatedModerationIndexRoute
  '/platform-config': typeof AuthenticatedPlatformConfigIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/platform-config/$namespace': typeof AuthenticatedPlatformConfigNamespaceRoute
  '/support/$id': typeof AuthenticatedSupportIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/access': typeof AuthenticatedAccessIndexRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/controls': typeof AuthenticatedControlsIndexRoute
  '/moderation': typeof AuthenticatedModerationIndexRoute
  '/platform-config': typeof AuthenticatedPlatformConfigIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/platform-config/$namespace': typeof AuthenticatedPlatformConfigNamespaceRoute
  '/_authenticated/support/$id': typeof AuthenticatedSupportIdRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/access/': typeof AuthenticatedAccessIndexRoute
  '/_authenticated/audit/': typeof AuthenticatedAuditIndexRoute
  '/_authenticated/controls/': typeof AuthenticatedControlsIndexRoute
  '/_authenticated/moderation/': typeof AuthenticatedModerationIndexRoute
  '/_authenticated/platform-config/': typeof AuthenticatedPlatformConfigIndexRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/'
    | '/platform-config/$namespace'
    | '/support/$id'
    | '/users/$userId'
    | '/access'
    | '/audit'
    | '/controls'
    | '/moderation'
    | '/platform-config'
    | '/support'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/platform-config/$namespace'
    | '/support/$id'
    | '/users/$userId'
    | '/access'
    | '/audit'
    | '/controls'
    | '/moderation'
    | '/platform-config'
    | '/support'
    | '/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/'
    | '/_authenticated/platform-config/$namespace'
    | '/_authenticated/support/$id'
    | '/_authenticated/users/$userId'
    | '/_authenticated/access/'
    | '/_authenticated/audit/'
    | '/_authenticated/controls/'
    | '/_authenticated/moderation/'
    | '/_authenticated/platform-config/'
    | '/_authenticated/support/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/platform-config/': {
      id: '/_authenticated/platform-config/'
      path: '/platform-config'
      fullPath: '/platform-config'
      preLoaderRoute: typeof AuthenticatedPlatformConfigIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/moderation/': {
      id: '/_authenticated/moderation/'
      path: '/moderation'
      fullPath: '/moderation'
      preLoaderRoute: typeof AuthenticatedModerationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/controls/': {
      id: '/_authenticated/controls/'
      path: '/controls'
      fullPath: '/controls'
      preLoaderRoute: typeof AuthenticatedControlsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/audit/': {
      id: '/_authenticated/audit/'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/access/': {
      id: '/_authenticated/access/'
      path: '/access'
      fullPath: '/access'
      preLoaderRoute: typeof AuthenticatedAccessIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/support/$id': {
      id: '/_authenticated/support/$id'
      path: '/support/$id'
      fullPath: '/support/$id'
      preLoaderRoute: typeof AuthenticatedSupportIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/platform-config/$namespace': {
      id: '/_authenticated/platform-config/$namespace'
      path: '/platform-config/$namespace'
      fullPath: '/platform-config/$namespace'
      preLoaderRoute: typeof AuthenticatedPlatformConfigNamespaceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedPlatformConfigNamespaceRoute: typeof AuthenticatedPlatformConfigNamespaceRoute
  AuthenticatedSupportIdRoute: typeof AuthenticatedSupportIdRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedAccessIndexRoute: typeof AuthenticatedAccessIndexRoute
  AuthenticatedAuditIndexRoute: typeof AuthenticatedAuditIndexRoute
  AuthenticatedControlsIndexRoute: typeof AuthenticatedControlsIndexRoute
  AuthenticatedModerationIndexRoute: typeof AuthenticatedModerationIndexRoute
  AuthenticatedPlatformConfigIndexRoute: typeof AuthenticatedPlatformConfigIndexRoute
  AuthenticatedSupportIndexRoute: typeof AuthenticatedSupportIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedPlatformConfigNamespaceRoute:
    AuthenticatedPlatformConfigNamespaceRoute,
  AuthenticatedSupportIdRoute: AuthenticatedSupportIdRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedAccessIndexRoute: AuthenticatedAccessIndexRoute,
  AuthenticatedAuditIndexRoute: AuthenticatedAuditIndexRoute,
  AuthenticatedControlsIndexRoute: AuthenticatedControlsIndexRoute,
  AuthenticatedModerationIndexRoute: AuthenticatedModerationIndexRoute,
  AuthenticatedPlatformConfigIndexRoute: AuthenticatedPlatformConfigIndexRoute,
  AuthenticatedSupportIndexRoute: AuthenticatedSupportIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
